import React, { useEffect, useRef } from "react";
import classes from "./Footer.module.css";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import { useDispatch } from "react-redux";
import { ScrollActions } from "../../store/Slices/ScrollSlice";

import logo from "../../images/logoHD.png";
import facebook from "../../images/socials/facebook.png";
import twitter from "../../images/socials/twitter.png";
import linkedin from "../../images/socials/linkedin.png"; //add it when LWAH creates a LinkedIn account
import youtube from "../../images/socials/youtube.png";
import instagram from "../../images/socials/instagram.png";

//This component renders the footer that container the social media links
/*
props.enableScroll: THis should be true only on the main page where ScrollProgress is active
 */
const Footer = (props) => {
  const dispatch = useDispatch();
  const container = useRef(null);

  gsap.registerPlugin(ScrollTrigger);
  //This useEffect keeps track of the scroll position of this component for ScrollProgress Component
  useEffect(() => {
    let trigger;
    if (props.enableScroll) {
      trigger = ScrollTrigger.create({
        trigger: container.current,
        start: "top bottom",
        end: "bottom bottom",
        scrub: true,
        // markers: true,
        onUpdate: (self) => {
          // console.log("progress", self.progress);
          dispatch(ScrollActions.UpdateFooter(self.progress));
        },
      });
    }

    return () => {
      if (props.enableScroll) {
        trigger.kill();
      }
    };
  }, []);

  return (
    <div className={classes.container} ref={container}>
      <div className={classes.column}>
        <img src={logo} alt="logo" />
      </div>
      <div className={classes.column + " " + classes.connect}>
        <h1>Connect</h1>
        <div className={classes.socials}>
          <a
            href="https://www.facebook.com/LebaneseWelfareAssociationfortheHandicapped/"
            target="_blank"
          >
            <img src={facebook} alt="facebook" />
          </a>
          <a href="https://twitter.com/LWAHngo" target="_blank">
            <img src={twitter} alt="twitter" />
          </a>
          <a
            href="https://www.youtube.com/channel/UC1kz-SfIQE816pHWcUglqiQ"
            target="_blank"
          >
            <img src={youtube} alt="youtube" />
          </a>
          <a href="https://www.instagram.com/lwahofficial/" target="_blank">
            <img src={instagram} alt="instagram" />
          </a>
        </div>
        <h6>
          Copyright © 2026 <span className={classes.yellow}>LWAH</span>. All
          rights reserved.
        </h6>
      </div>
      <div className={classes.column}>
        <img src={logo} alt="logo" />
      </div>
    </div>
  );
};
export default Footer;
